(function() {
    var $specifies = $('[data-specify]');

    $specifies.each(function(_, input) {
        var $input = $(input);
        var name = $input.attr('name');
        var valueToWatch = $input.val();
        var targetSelector = $input.attr('data-specify');
        var $target = $(targetSelector);

        if ($target.length === 0) {
            console.warn('[Specify Fields] No target founds', $target);
            return;
        }

        // On radio group change
        $('input[name="'+ name +'"]').on('change', function() {
            var value = $(this).val();

            if (value === valueToWatch) {
                $target.prop('required', true);
                $target.closest('.form-group').show();
            } else {
                $target.prop('required', false);
                $target.closest('.form-group').hide();
            }
        });
    });
})();
